import { FC, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const EmbedLayout: FC<Props> = ({ children }) => {
  return (
    <>
      <style jsx global>
        {`
          html,
          body,
          #__next {
            overflow: visible !important;
            height: auto !important;
            width: 100% !important;
            min-height: auto !important;
            max-height: none !important;
            position: static !important;
          }
          #faradars-main {
            height: auto !important;
            min-height: none !important;
          }
        `}
      </style>
      {children}
    </>
  );
};

export default EmbedLayout;
